var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "2.0 2.0 60.0 60.0",
    width: 60,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.101,17.858L17.858,22.1l2.359,2.359c-0.879,1.37-1.528,2.9-1.886,4.541H15v6h3.33c0.359,1.641,1.006,3.173,1.885,4.542 l-2.357,2.357l4.243,4.243l2.357-2.357c1.37,0.878,2.901,1.526,4.542,1.885V49h6v-3.33c1.641-0.359,3.17-1.008,4.541-1.886 l2.359,2.359l4.243-4.243l-2.359-2.359c0.879-1.37,1.528-2.9,1.886-4.541H49v-6h-3.33c-0.359-1.641-1.006-3.173-1.885-4.542 l2.357-2.357l-4.243-4.243l-2.357,2.357c-1.37-0.878-2.901-1.526-4.542-1.885V15h-6v3.33c-1.641,0.359-3.17,1.008-4.541,1.886 L22.101,17.858z M32,23c4.971,0,9,4.029,9,9c0,4.971-4.029,9-9,9s-9-4.029-9-9C23,27.029,27.029,23,32,23z",
    fill: "inherit"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 5,
    fill: "inherit",
    r: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 59,
    fill: "inherit",
    r: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 31,
    fill: "inherit",
    r: 3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change1_5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 32,
    fill: "inherit",
    r: 3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change1_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.367,7.897l0.734,2.203l5-5l-7-1l0.623,1.869C12.136,9.913,6.671,17.256,5.1,25.631L7.065,26 C8.505,18.328,13.468,11.594,20.367,7.897z",
    fill: "inherit"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change1_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1,37.999l-1,7l1.869-0.623C10.913,51.964,18.256,57.429,26.631,59L27,57.035c-7.672-1.44-14.406-6.403-18.103-13.302 l2.203-0.734L6.1,37.999z",
    fill: "inherit"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "change1_8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.001,37.469L57.036,37.1c-1.44,7.672-6.403,14.406-13.302,18.103L43,53l-5,5l7,1l-0.623-1.869 C51.965,53.187,57.43,45.845,59.001,37.469z",
    fill: "inherit"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "change1_9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.204,19.367l-2.203,0.734l5,5l1-7l-1.869,0.623C53.188,11.136,45.846,5.671,37.47,4.1l-0.369,1.965 C44.773,7.505,51.507,12.468,55.204,19.367z",
    fill: "inherit"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.92b18e5c9e199faccb58570d6d32606d.svg";
export { ForwardRef as ReactComponent };